import React, { Component } from 'react'
import PropTypes from 'prop-types'

import Breadcrumbs from './../block/Breadcrumbs'
import FAQSection from './../block/FAQSection'
import TestimonialsSection from './../block/TestimonialsSection'

export default class Faq extends Component {

  render() {

    const { data, ajax_data, user_profile_type } = this.props

    return (
      <>
        <Breadcrumbs items={ajax_data.breadcrumbs} />
        <FAQSection
          qwestions={user_profile_type == `legal` ? ( ajax_data?.qwestions_ng_legal || [] ) : ( ajax_data?.qwestions_ng || [] )}
        />
        <TestimonialsSection
          page_data={data?.page_data || {}}
          feedback={ajax_data?.feedback_ng || []}
          feedback_legal={ajax_data?.feedback_ng_legal || []}
          user_profile_type={user_profile_type}
        />
      </>
    )
  }
}

Faq.propTypes = {
  data: PropTypes.object,
  ajax_data: PropTypes.object
}